import styled from 'styled-components';

import ColormapInterface from 'shared-types/colormapinterface';
import { getSpacing, fontSize, fontWeight } from 'stylesheetB2b';

export const MenuItemStyle = styled.div<{ colors: ColormapInterface }>`
  display: flex;
  height: ${getSpacing(9)};
  width: ${getSpacing(45)};
  color: ${({ colors }) => colors.popoverItem};
  background-color: ${({ colors }) => colors.popoverItemBackground};
  font-size: ${fontSize.small};
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: ${getSpacing(1)};
  padding-left: ${getSpacing(3)};
  font-weight: ${fontWeight.light};
  border-bottom: solid ${getSpacing(0.1)} ${({ colors }) => colors.popoverItemBorder};
`;
